import { Container, Box, Button, IconProps } from "@cloudscape-design/components"
import { CardSummaryProp } from "types/organizationTypes"

function CardSummary({icon, stats, buttonPosition="left", buttonText, disabledButton, buttonAction, buttonIcon, text, lightText, boldText, onClick, className}: CardSummaryProp) {
  return (
    <div className={`card-summary ${className ? className : ""}`}  onClick={onClick}>
      <Container
        header={
          <div className="card-style">
            <div>
              {icon}
            </div>
            {stats?.map((stat, index)=>
              <div className={`card-header-section ${stat.clickable ? "clickable" : ""}`} key={index} onClick={stat.action ?? undefined}>
                <Box variant="h2">{stat.count}</Box>
                <Box variant="small">{stat.text}</Box>
              </div>
            )}  
          </div>
        }
        fitHeight
      >
        <div className="cards-main-container">
          <div className="cards-main-container-text">
            {boldText && <div style={{fontSize: "25px", marginBottom: "10px"}}><strong>{boldText}</strong></div>}
            {text && <div>{text}</div>}
            {lightText && <div style={{color: "gray"}}>{lightText}</div>}
          </div>

          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: buttonPosition === "left" ? "row" : "row-reverse"}}>
            <Button iconName={buttonIcon ? buttonIcon as IconProps.Name : undefined} onClick={buttonAction} disabled={disabledButton}>{buttonText}</Button>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default CardSummary
